export default __webpack_public_path__ + "static/media/eth-icon.609bed68.svg";